import type { AxiosRequestConfig } from 'axios';

import { getObjectWithoutEmptyValues, transformObjectToSnakeCase } from '@utilities';

import type { ReadSurveyResponseParams } from './types';
import { getWithCredentials } from '@api/survey_dashboard/utilities/helpers';

export const getSurveyResponseRequestConfig = ({
  publicToken,
  query = {},
  signal,
  surveyId,
}: ReadSurveyResponseParams): Pick<
  AxiosRequestConfig,
  'method' | 'params' | 'signal' | 'withCredentials'
> => ({
  method: 'get',
  params: {
    ...getObjectWithoutEmptyValues(transformObjectToSnakeCase(query) as object),
    publicToken,
    survey_id: surveyId,
  },
  signal,
  withCredentials: getWithCredentials({ publicToken }),
});
